import React from 'react';
import './assets/css/style.css';
import { useDispatch, useSelector } from "react-redux";
import {
    setAnswer,
    setComputingAnswer,
    setDataChannel,
    setIsVerifiedLogin,
    setSessionId,
    setSlideData,
    setStreamData,
    setStreamStatus,
    setThreadId,
    setWelcome
} from "./store/reducers/questionReducer";
import { config } from "./config";
import { Stream } from "./components/Stream";
import { Question } from "./components/Question";
import { Header } from "./components/Header";
import { LandingHeader } from "./components/LandingHeader";
import { Chat } from "./components/Chat";
import useInactiveUserDetector from './hooks/useInactiveUserDetector';
import { createThreadApi, saveQaAnalytics, sendAvatarRequest, updateProfile } from './services/api';
import { Launch } from "./components/Launch";
import { Login } from './components/Login';
import { Loader } from './components/Loader';
import PlayAnimation from './components/PlayAnimation';
import avatarImage from "./assets/images/avatarimg.png";
import davidAvatarImage from "./assets/images/david-avatarimg.png";
import willKnightAvatarImage from "./assets/images/willknight-avatarimg.png";
import skyAvatarImage from "./assets/images/sky-avatarimg.png";
import aaronAvatarImage from "./assets/images/aaron-avatar.png";
import bridgetAvatarImage from "./assets/images/bridget-avatar.png";
import allisonHornAvatarImage from "./assets/images/allisonhorn-avatarimg.jpg";
import paulGoldingAvatarImage from "./assets/images/paul-golding-avatarimg.jpg";
import nicolasBaratteAvatarImage from "./assets/images/nicolas-baratte-avatarimg.jpg";
import cherryMaAvatarImage from "./assets/images/cherryma-avatarimg.jpg";
import smithCodioAvatarImage from "./assets/images/smithcodio-avatarimg.jpg";
import frederickHavemeyerAvatarImage from "./assets/images/frederick-havemeyer-avatarimg.jpg";
import rajivChandranAvatarImage from "./assets/images/rajivchandran-avatarimg.jpg";
import jonGordonAvatarImage from "./assets/images/jongordon-avatarimg.jpg";
import liorLavidAvatarImage from "./assets/images/liorlavid-avatarimg.jpg";
import danaKochAvatarImage from "./assets/images/danakoch-avatarimg.jpg";
import johnGoodyerAvatarImage from "./assets/images/johngoodyer-avatarimg.jpg";
import simonHollandAvatarImage from "./assets/images/simonholland-avatarimg.jpg";
import jessMajekodunmiAvatarImage from "./assets/images/jessmajekodunmi-avatarimg.jpg";
import philipMoyerAvatarImage from "./assets/images/philipmoyer-avatarimg.jpg";
import reidHoffmanAvatarImage from "./assets/images/reidhoffman-avatarimg.jpg";
import drCamilleKandikoHowsonAvatarImage from "./assets/images/drcamillekandikohowson-avatarimg.jpg";
import kathyChenAvatarImage from "./assets/images/kathychen-avatarimg.jpg";
import tierneyMorganAvatarImage from "./assets/images/tierneymorgan-avatarimg.jpg";
import bobGerardAvatarImage from "./assets/images/bobgerard-avatarimg.jpg";
import susanGoodyerAvatarImage from "./assets/images/susangoodyer-avatarimg.jpg";
import bartClarysseAvatarImage from "./assets/images/bart-clarysse-avatarimg.jpg";
import omarMerloAvatarImage from "./assets/images/omar-merlo-avatarimg.jpg";
import markKennedyAvatarImage from "./assets/images/mark-kennedy-avatarimg.jpg";


import ethanLawsonAvatarImage from "./assets/images/ethan-lawson.png";
import sophiaMartinezAvatarImage from "./assets/images/sophia-martinez.png";
import edoSegalAvatarImage from "./assets/images/edosegal-avatarimage.jpg";
import johnSamuelAvatarImage from "./assets/images/john-samuel.png";
import isabellaWongAvatarImage from "./assets/images/isabella-wong.png";

import { getApiUrl, getPdfBackendUrl } from './helpers/util';
import { InActiveScreen } from './components/InActiveScreen';
import { IntroVideo } from './components/IntroVideo';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Social } from './components/social';



declare global {
    interface Window {
        hls: any;
        Hls: any;
        chatOnly: any;
    }
}

interface AnswerResponse {
    sdp?: string;
    type?: string;
}

interface ApiResponse {
    answer?: AnswerResponse | undefined
    session_id?: string
    code?: number;
    message?: string;
}

let startedStream = false;

function App() {
    const dispatch = useDispatch();
    const isActive = useInactiveUserDetector();


    const streamData = useSelector((state: any) => state.questionReducer.streamData);
    const firstQuestionAsked = useSelector((state: any) => state.questionReducer.firstQuestionAsked);
    const isChatMode = useSelector((state: any) => state.questionReducer.isChatMode);
    let avatarId = useSelector((state: any) => state.questionReducer.avatarId);
    const profilePath = useSelector((state: any) => state.questionReducer.profilePath);
    const showExperience = useSelector((state: any) => state.questionReducer.showExperience);
    const isAuthenticated = useSelector((state: any) => state.questionReducer.isAuthenticated);
    const isVerifiedLogin = useSelector((state: any) => state.questionReducer.isVerifiedLogin);
    const animationDOMRects = useSelector((state: any) => state.questionReducer.animationDOMRects);
    const cartDOMRects = useSelector((state: any) => state.questionReducer.cartDOMRects);
    const vectorStoreId = useSelector((state: any) => state.questionReducer.vectorStoreId);
    const threadId = useSelector((state: any) => state.questionReducer.threadId);

    const [heartbeatInterval, setHeartbeatInterval] = React.useState<any>(null);
    const [stopStream, setStopStream] = React.useState<boolean>(false);
    const [animation, setAnimation] = React.useState<boolean>(false);
    const [streamStarted, setStreamStarted] = React.useState<boolean>(false);
    const [createStream, setCreateStream] = React.useState<boolean>(false);
    const [peerConnection, setPeerConnection] = React.useState<any>(null);

    const streamDataRef = React.useRef(streamData);
    const stopRef = React.useRef(stopStream);
    const createStreamRef = React.useRef(createStream);
    const [socketPresenceService, setSocketPresenceService] = React.useState<any>(null);
    const [socketConnected, setSocketConnected] = React.useState<any>(null);
    const socketPresenceServiceRef = React.useRef(socketPresenceService);
    const bio = useSelector((state: any) => state.questionReducer.bio);
    const name = useSelector((state: any) => state.questionReducer.name);
    const company = useSelector((state: any) => state.questionReducer.company);
    const email = useSelector((state: any) => state.questionReducer.email);
    const jobTitle = useSelector((state: any) => state.questionReducer.role);
    const avatarMuted = useSelector((state: any) => state.questionReducer.avatarMuted);
    const introUrl = useSelector((state: any) => state.questionReducer.introUrl);
    const introDoNotShow = useSelector((state: any) => state.questionReducer.introDoNotShow);
    const chatAnswers = useSelector((state: any) => state.questionReducer.chatAnswers);
    const activeRef = React.useRef(isActive);


    const intro = introUrl != '';
    const [showIntro, setShowIntro] = React.useState<boolean>(intro);

    let socketConnectInitiated = false;
    const createThread = async () => {
        const result = await createThreadApi({ vector_store_id: vectorStoreId, version: "azure" });
        if (result?.data?.success && result?.data?.thread_id) {
            dispatch(setThreadId(result?.data?.thread_id));
        }
    };
    React.useEffect(() => {
        socketPresenceServiceRef.current = socketPresenceService;
    }, [socketPresenceService])

    // React.useEffect(() => {
    //     //Re trigger stream
    //     if(avatarMuted === true) {
    //         startStream();
    //     }
    // }, [avatarMuted])

    React.useEffect(() => {
        (async () => {
            if ((!window.chatOnly) && isAuthenticated === true && isVerifiedLogin === true) {
                let avatarStatus = (window as any).avatarStatus;

                if (avatarStatus != 'frames_ready' && avatarStatus != 'completed') {
                    const requestData = {
                        url: config.avatarStatusServer + "/stablediffusion/api/avatar/profile/get/" + avatarId,
                        method: 'get',
                        data: null
                    }
                    const avatarResult = await sendAvatarRequest(requestData);
                    avatarStatus = avatarResult.data.status;
                    const updateParams = {
                        profile_path: profilePath,
                        avatar_id: avatarId,
                        avatar_status: avatarStatus,
                        avatar_video_link: avatarResult.data.videos?.length > 0 ? avatarResult.data.videos[0].original_video_url : ''
                    }
                    await updateProfile(updateParams);

                }

                if ((avatarStatus == 'completed' || avatarStatus == 'frames_ready') && !startedStream && !createStreamRef.current) {
                    startWebrtc();
                    startedStream = true;
                    setCreateStream(true)
                }
            }
        })();
        return () => {
        };
    }, [isVerifiedLogin, isAuthenticated])

    React.useEffect(() => {
        if (!socketConnectInitiated) {
            connect();
            socketConnectInitiated = true;
            if (vectorStoreId && vectorStoreId !== '') {
                createThread();
            }

        }
        // Verify login
        dispatch(setIsVerifiedLogin(true));
    }, [])

    React.useEffect(() => {
        streamDataRef.current = streamData;
    }, [streamData])

    React.useEffect(() => {
        if (socketConnected) {
            if (profilePath !== 'simonholland' && profilePath !== 'danakoch' && profilePath !== 'johngoodyer' && profilePath !== 'jessmajekodunmi' && profilePath !== 'susangoodyer' && profilePath !== 'bartclarysse' && profilePath !== 'omarmerlo' && profilePath !== 'markkennedy') {
                sendWelcome();
            }
        }
    }, [socketConnected])

    React.useEffect(() => {
        createStreamRef.current = createStream;
    }, [createStream])

    React.useEffect(() => {
        stopRef.current = stopStream;
    }, [stopStream])

    React.useEffect(() => {
        if (showExperience === true) {
            setAnimation(true);

            setTimeout(() => {
                setAnimation(false);
            }, 100)
        }
    }, [showExperience])

    React.useEffect(() => {
        activeRef.current = isActive;
        if (!isActive && peerConnection) {
            peerConnection.close();
        }
    }, [isActive])
    const removeSpecialCharacters = (text: string) => {
        return text
            .replace(/[_*~`>#]/g, "") // Remove basic Markdown symbols like _, *, ~, `, #, >, -
            .replace(/\[(.*?)\]\(.*?\)/g, "$1") // Convert [text](link) to text
            .replace(/!\[.*?\]\(.*?\)/g, "") // Remove image markdown ![alt](url)
            .replace(/`{3}[\s\S]*?`{3}/g, "") // Remove code blocks ```code```
            .replace(/`([^`]+)`/g, "$1") // Convert inline `code` to just text
            .replace(/-{3,}/g, "") // Remove horizontal rules (--- or ***)
            .replace(/\n{2,}/g, "\n") // Convert multiple newlines to a single newline
            .trim(); // Remove leading and trailing whitespace
    };

    const connect = async () => {
        let url = getPdfBackendUrl();
        const fetchUrl = url.replace("wss", "https").replace('ws', 'http');
        await fetch(fetchUrl);

        //Socket Connection
        const connection = new WebSocket(url);
        setSocketPresenceService(connection);

        connection.onopen = function () {
            if (heartbeatInterval === null) {
                const hrtbt = setInterval(() => {
                    connection.send('heartbeat');
                }, 4000);
                setHeartbeatInterval(hrtbt);
            }
            let connected: any = true;
            setSocketConnected(connected);
        };
        connection.onclose = function (e) {
            setTimeout(function () {
                connect();
            }, 2000);
        };
        connection.onerror = function (error: any) {
            console.log('WebSocket Error ', error);
        };
        connection.onmessage = async function (event: any) {
            let data = JSON.parse(event.data);
            if (data.response_type === 'profile-welcome') {
                if (data.status === 'Success') {
                    dispatch(setWelcome(data.answer));
                }
            } else if (data.response_type === 'profile-slide') {
                dispatch(setSlideData(data));
            } else {
                let dataContent = data;
                    if (dataContent?.answer) {
                        dataContent.answer = removeSpecialCharacters(dataContent?.answer)
                    }
                if (data.status === 'Success') {
                    dispatch(setStreamStatus('Success'))
                    
                    dispatch(setAnswer(dataContent));
                    //Save answer
                    let requestData = {
                        question: data.query,
                        answer: data.answer,
                        email: (window as any).email,
                        profile_path: profilePath,
                        cogcache_cache_entry_id: data.cogcache_cache_entry_id
                    };
                    saveQaAnalytics(requestData);

                } else {
                    //Enable if stream
                    // dispatch(setAnswer(data));
                }
                dispatch(setComputingAnswer(dataContent));
            }
        }
    }


    function sendDataToSocket(data: any) {
        socketPresenceServiceRef.current.send(data);
    }

    function sendWelcome() {
        sendDataToSocket(JSON.stringify({
            question_uid: 'welcome',
            response_type: 'profile-welcome',
            client: profilePath,
            name,
            job_title: jobTitle,
            bio
        }));
    }

    const negotiate = async (pc: RTCPeerConnection): Promise<void> => {
        try {
            /*let avatarFreeServerUrl = config.avatarApiUrl + "/api/getFreeServer";
            if ((window as any).investorEmail && ((window as any).investorEmail === 'monica.kim@accenture.com' || (window as any).investorEmail === 'abhi@touchcast.com')) {
                const apiUrl = getApiUrl();
                avatarFreeServerUrl = apiUrl + "get-free-server?path=" + profilePath;
            }*/

            const apiUrl = getApiUrl();
            let avatarFreeServerUrl = apiUrl + "get-free-server?path=" + profilePath;

            const response = await fetch(avatarFreeServerUrl);
            if (response.status === 204) {
                throw new Error("There are no available servers");
            }

            const content = await response.json();
            const url = content.url;

            pc.addTransceiver('video', { direction: 'recvonly' });
            pc.addTransceiver('audio', { direction: 'recvonly' });

            console.log('Creating offer');
            const offer = await pc.createOffer();
            console.log('Setting local description');
            await pc.setLocalDescription(offer);

            console.log('Waiting for ICE gathering to complete');
            await new Promise<void>((resolve) => {
                if (pc.iceGatheringState === 'complete') {
                    resolve();
                } else {
                    const checkState = () => {
                        if (pc.iceGatheringState === 'complete') {
                            pc.removeEventListener('icegatheringstatechange', checkState);
                            resolve();
                        }
                    };
                    pc.addEventListener('icegatheringstatechange', checkState);
                }
            });

            console.log('ICE gathering completed');

            // Set avatarId based on profilePath
            switch (profilePath) {
                case 'edo-segal':
                    avatarId = 'a7b85217-0e16-4772-b888-b762fed9920c';
                    break;
                case 'david':
                case 'david-shrier':
                    avatarId = '8a6dcbca-3b4c-4a5e-8ba1-e48beb9b8caf';
                    break;
                case 'will-knight':
                    avatarId = '9b9490fa-9ad8-4aa3-bb78-3d6a1c34b33d';
                    break;
                case 'sky':
                    avatarId = '945e822d-25a5-467a-a326-c1b21e26a865';
                    break;
                case 'aaronrafferty':
                    avatarId = '153f3aa0-c2e5-4223-a46c-a8037406b2fa';
                    break;
                case 'bridgetrichards':
                    avatarId = 'b175f53c-2289-4750-b8eb-06d91aafb948';
                    break;
                case 'allisonhorn':
                    avatarId = 'b9452d17-f163-4d4c-9496-759bc31635ef';
                    break;
                case 'paulgolding':
                    avatarId = '3b2dbe3e-b3c2-44ea-b640-2e1e0533289d';
                    break;
                case 'nicolasbaratte':
                    avatarId = '016e6c8b-85c8-415b-a8de-19a1a09dc34f';
                    break;
                case 'cherryma':
                    avatarId = '952ccbf5-f76f-4722-a36f-f60af1520303';
                    break;
                case 'frederickhavemeyer':
                    avatarId = '8b04accd-9f4c-4ace-8be1-14ecffdcfaf3';
                    break;
                case 'rajivchandran':
                    avatarId = '944dab8d-5df4-4893-8323-7272175b2481';
                    break;
                case 'smithcodio':
                    avatarId = '53f68acc-d974-44b5-b7af-6ec75acb1428';
                    break;
                case 'jongordon':
                    avatarId = 'e1e1c4e0-1847-4b91-9dea-07cf174aaa92';
                    break;
                case 'liorlavid':
                    avatarId = 'a49c7ee0-d482-4348-9895-572e7257f155';
                    break;
                case 'danakoch':
                    avatarId = 'a631d5d9-1af1-45b2-b503-0d57dcec1ed1';
                    break;
                case 'johngoodyer':
                    avatarId = '9101c87d-4947-4e7e-84de-41d759f61640';
                    break;
                case 'jessmajekodunmi':
                    avatarId = '615ce482-7626-4358-8b2a-e153c1aff7a6';
                    break;
                case 'simonholland':
                    avatarId = '0fde8244-d8b1-4f7a-9968-fab7e475fb70';
                    break;
                case 'philipmoyer':
                    avatarId = 'b87a12ee-c3d8-4a7b-a368-d83da12434aa';
                    break;
                case 'reidhoffman':
                    avatarId = '302cfdcc-5e3a-4430-bf7b-7a796413d0bb';
                    break;
                case 'drcamillekandikohowson':
                    avatarId = 'a8063fbf-1d13-4fea-a02b-09bc8b871479';
                    break;
                case 'kathychen':
                    avatarId = '64df778f-ba77-459a-b39d-78a9deee2a82';
                    break;
                case 'tierneymorgan':
                    avatarId = '1f84968a-6625-427d-a277-ed548f022fc6';
                    break;
                case 'bobgerard':
                    avatarId = 'fac28731-748a-4c28-bc66-808966ab4ac6';
                    break;
                case 'susangoodyer':
                    avatarId = '4110b8b9-86ea-4d4e-b305-e5ebbf16eaa9';
                    break;
                case 'bartclarysse':
                    avatarId = '823ae9d4-af36-4492-af58-22384f62035b';
                    break;
                case 'omarmerlo':
                    avatarId = '0c914e0a-136a-49e5-9d77-37f1497e43b8';
                    break;
                case 'markkennedy':
                    avatarId = '7be7bad5-27da-4bd3-b33f-169bd8b08bd7';
                    break;
            }
            const offerLocal = pc.localDescription;
            let orgId = config.orgId;

            const offerResponse = await fetch(`${url}/api/offer`, {
                body: JSON.stringify({
                    sdp: offerLocal?.sdp,
                    type: offerLocal?.type,
                    payload: {
                        avatarId: avatarId,
                        organizationId: orgId,
                    },
                }),
                headers: {
                    "Content-Type": "application/json",
                },
                method: "POST",
            });

            if (offerResponse.status === 204) {
                console.log('Received 204, restarting negotiation...');
                return negotiate(pc); // Recursively restart the negotiation
            }

            const contentOffer: any = await offerResponse.json();
            dispatch(setSessionId(contentOffer.session_id));
            const answer = contentOffer.answer;

            if (contentOffer.code === 429) {
                console.log('429 error', contentOffer.message);
            } else {
                if (answer?.sdp && answer.type) {
                    if (pc.signalingState === 'have-local-offer') {
                        await pc.setRemoteDescription(answer as RTCSessionDescriptionInit);
                        setStreamStarted(true); // Handle stream start
                    } else {
                        throw new Error('Invalid state for setting remote description');
                    }
                } else {
                    throw new Error('Invalid remote description');
                }
            }
        } catch (error) {
            console.log(`Negotiation failed: ${error}`);
        }
    };


    function startWebrtc() {
        let config = {
            sdpSemantics: "unified-plan",
            iceServers: [
                { urls: "stun:stun1.ciscape.com:3478" },
                {
                    urls: "turn:stun1.ciscape.com:3478",
                    username: "tcuser",
                    credential: "dw4k_BR2f-Y4A-@aT7ip@Qzs",
                },
                { urls: "stun:129.146.43.226:3478" },
                { urls: "stun:stun.l.google.com:19302" },
                { urls: "stun:stun1.l.google.com:19302" },
                {
                    urls: "turn:129.146.43.226:3478",
                    username: "teamtime_turn",
                    credential: "teamtime",
                }
            ]

        };
        let pc = new RTCPeerConnection(config);
        setPeerConnection(pc);

        // connect audio / video
        pc.addEventListener("track", function (evt) {
            if (evt.track.kind === "video") {
                console.log(evt.streams[0])
                dispatch(setStreamData({ ...streamDataRef.current, streamUrl: evt.streams[0] }))
            } else {
                dispatch(setStreamData({ ...streamDataRef.current, audioStreamUrl: evt.streams[0] }))
            }
        });

        // data channel
        let parameters = { ordered: true };
        let dataChannel = pc.createDataChannel("chat", parameters);
        dispatch(setDataChannel(dataChannel))
        dataChannel.onopen = function () {
            console.log("Data channel opened");
        };
        dataChannel.onmessage = function (evt) {
            console.log(evt.data);
        };
        dataChannel.onclose = function () {
            console.log("Data channel closed");
        };
        dataChannel.onerror = function (ev) {
            console.log(ev);
        };

        negotiate(pc)
    }

    let image: any = (window as any).avatarImage ? (window as any).avatarImage : avatarImage;
    if (profilePath === 'david' || profilePath === 'david-shrier') {
        image = davidAvatarImage;
    }
    if (profilePath === 'will-knight') {
        image = willKnightAvatarImage;
    }
    if (profilePath === 'sky') {
        image = skyAvatarImage;
    }
    if (profilePath === 'bridgetrichards') {
        image = bridgetAvatarImage;
    }
    if (profilePath === 'aaronrafferty') {
        image = aaronAvatarImage;
    }
    if (profilePath === 'allisonhorn') {
        image = allisonHornAvatarImage;
    }
    if (profilePath === 'paulgolding') {
        image = paulGoldingAvatarImage;
    }
    if (profilePath === 'nicolasbaratte') {
        image = nicolasBaratteAvatarImage;
    }
    if (profilePath === 'cherryma') {
        image = cherryMaAvatarImage;
    }
    if (profilePath === 'frederickhavemeyer') {
        image = frederickHavemeyerAvatarImage;
    }
    if (profilePath === 'rajivchandran') {
        image = rajivChandranAvatarImage;
    }
    if (profilePath === 'smithcodio') {
        image = smithCodioAvatarImage;
    }
    if (profilePath === 'jongordon') {
        image = jonGordonAvatarImage;
    }
    if (profilePath === 'liorlavid') {
        image = liorLavidAvatarImage;
    }
    if (profilePath === 'danakoch') {
        image = danaKochAvatarImage;
    }
    if (profilePath === 'johngoodyer') {
        image = johnGoodyerAvatarImage;
    }
    if (profilePath === 'simonholland') {
        image = simonHollandAvatarImage;
    }
    if (profilePath === 'jessmajekodunmi') {
        image = jessMajekodunmiAvatarImage;
    }
    if (profilePath === 'philipmoyer') {
        image = philipMoyerAvatarImage;
    }
    if (profilePath === 'reidhoffman') {
        image = reidHoffmanAvatarImage;
    }
    if (profilePath === 'drcamillekandikohowson') {
        image = drCamilleKandikoHowsonAvatarImage;
    }
    if (profilePath === 'kathychen') {
        image = kathyChenAvatarImage;
    }
    if (profilePath === 'tierneymorgan') {
        image = tierneyMorganAvatarImage;
    }
    if (profilePath === 'bobgerard') {
        image = bobGerardAvatarImage;
    }

    if (profilePath === 'edosegal') {
        image = edoSegalAvatarImage;
    }

    if (profilePath === 'john-samuel') {
        image = johnSamuelAvatarImage;
    }

    if (profilePath === 'isabella-wong') {
        image = isabellaWongAvatarImage;
    }

    if (profilePath === 'sophia-martinez') {
        image = sophiaMartinezAvatarImage;
    }

    if (profilePath === 'ethan-lawson') {
        image = ethanLawsonAvatarImage;
    }

    if (profilePath === 'susangoodyer') {
        image = susanGoodyerAvatarImage;
    }

    if (profilePath === 'bartclarysse') {
        image = bartClarysseAvatarImage;
    }

    if (profilePath === 'omarmerlo') {
        image = omarMerloAvatarImage;
    }

    if (profilePath === 'markkennedy') {
        image = markKennedyAvatarImage;
    }

    const showIntroVideo = introDoNotShow === false && showIntro === true;
    const page = (window as any).page ? (window as any).page : 'profile';
    const isFromOrgLandingPage = (window as any).isFromOrgLandingPage ? (window as any).isFromOrgLandingPage : '0';
    return (
        <div
            className={`${firstQuestionAsked ? "show-anim tc-main-wrapper di-main-wrapper" : "tc-main-wrapper di-main-wrapper"} ${(showExperience === false || animation === true) ? 'tc-launch-screen-center' : 'tc-main-chat-screen'} ${chatAnswers.length === 0 ? 'tc-chat-empty' : 'tc-chat-start-wrapper'}`}>
            {(page === 'social') ?
                (isVerifiedLogin === true && isAuthenticated === false) ?
                    <div className="di-main-wrapper" role="application">
                        <section className="di-exam-main-wrapper di-question-main-wrapper di-question-only">
                            <Login />
                        </section>
                    </div>
                    : <>{(isFromOrgLandingPage === '1') && <LandingHeader />} <Social
                        sendDataToSocket={sendDataToSocket} /></>

                :
                <>
                    <Header />
                    {(showIntroVideo === true && isVerifiedLogin === true && isAuthenticated === true) &&
                        <IntroVideo setShowIntro={setShowIntro} />
                    }


                    {isVerifiedLogin === false &&
                        <div className="tc-launch-wrapper">
                            <Loader />
                        </div>
                    }


                    {(showIntroVideo === false && isVerifiedLogin === true && isAuthenticated === true) &&
                        <Scrollbars style={{ minHeight: '100vh' }}>
                            <div className="tc-main-container">
                                {!showExperience &&
                                    <Launch stream={streamData} sendDataToSocket={sendDataToSocket} />
                                }

                                <div className={showExperience ? 'tc-chat-wrapper' : 'launch tc-chat-wrapper'}>
                                    <div className="tc-chat-container" id='tc-chat-container'>
                                        {(cartDOMRects && animationDOMRects) ?
                                            <PlayAnimation key={cartDOMRects.key} image={image} /> :
                                            <img className='dnone' src={image} />}
                                        <Stream stream={streamData} sendDataToSocket={sendDataToSocket}
                                            key={streamData.index} />
                                        <Chat />
                                    </div>
                                </div>

                            </div>
                        </Scrollbars>
                    }

                    {(isVerifiedLogin === true && isAuthenticated === false) &&
                        <div className="di-main-wrapper" role="application">
                            <section className="di-exam-main-wrapper di-question-main-wrapper di-question-only">
                                <Login />
                            </section>
                        </div>
                    }

                    {(showIntroVideo === false && showExperience && (!vectorStoreId || (vectorStoreId && threadId))) &&
                        <Question sendDataToSocket={sendDataToSocket} />
                    }
                    {(showIntroVideo === false && showExperience) && <div className="tc-chat-inner-gradient"></div>}
                </>}
            {isActive === false && <InActiveScreen />}

        </div>
    );
}

export default App;
